import ComplexNewRecordDetail from "@/server/com/silkplm/rpc/dto/ComplexNewRecordDetail";
import ComplexNewRecordExtension from "@/server/com/silkplm/rpc/dto/ComplexNewRecordExtension";

export default class TemporaryExtension{
    /**
     * @param {FormExtensionConfig} formExtensionConfig
     * @param {FormModel} formModel
     */
    constructor(formExtensionConfig, formModel) {

        /** @type {FormExtensionConfig} */
        this.formExtensionConfig = formExtensionConfig;
        /** @type {FormModel} */
        this.formModel = formModel;

        /** @type {BusinessRecord} */
        this.item = null;

        /** @type {boolean} */
        this.hasErrors = false;

        this.afterSaveStatus = "VALID";

        this.onUpdate = null;
        this.changes = false;
    }

    set(item){
        this.item = item;
        this.changes = true;
        if(this.afterSaveStatus !== "ERROR"){
            this.afterSaveStatus = "EDITED";
        }
    }

    refreshAfterSavedStatus(){
        let afterSaveStatus = this.changes ? "EDITED" : "VALID";

        const item = this.item;
        if(item == null){
            return;
        }
        if(item.__formModel__.currentAfterSaveStatus === "ERROR"){
            afterSaveStatus = "ERROR";
        } else {
            if (item.__formModel__.currentAfterSaveStatus === "EDITED") {
                afterSaveStatus = "EDITED";
            }
        }
        this.afterSaveStatus = afterSaveStatus;
        if(this.onUpdate){
            this.onUpdate();
        }
        this.formModel.refreshAfterSavedStatus();
    }

    collect(masterId){
        let extension = new ComplexNewRecordExtension();
        extension.clazz = this.formExtensionConfig.extensionClass;
        extension.field = this.formExtensionConfig.joiningField;

        if (!this.item?.__formModel__) {
            let x = 5;
        }
        let extensionItem = this.item.__formModel__.toComplexNewRecord();
        extensionItem.idToInjectIntoField = masterId;
        extension.item = extensionItem;

        return extension;
    }

    /**
     * @param {{number:InputValidationResult}} virtualIdToValidations
     */
    populateErrors(virtualIdToValidations){
        this.hasErrors = false;
        this.changes = false;
        this.afterSaveStatus = "VALID";

        this.item.__formModel__.populateErrors(virtualIdToValidations);
        if(!this.item.__formModel__.isValid){
            this.hasErrors = true;
            this.afterSaveStatus = "ERROR";
        }
    }
    /**
     * @param {{number:InputValidationResult}} virtualIdToValidations
     */
    populateIds(vIdToId){
        if (this.item?.__formModel__) {
            this.item.__formModel__.populateIds(vIdToId);
        }
    }
}